/* eslint-disable react/sort-comp */
import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import './BackToTop.style.scss';

export const BackToTop = (props) => {
  const [backToTop, setBackToTop] = useState(false);

  useEffect(() => {
    const onScrollEvent = () => {
      const { scrollBreakpoint } = props;
      const scroll = window.pageYOffset || document.documentElement.scrollTop;
      const newBackToTop = scroll > scrollBreakpoint;
      if (backToTop !== newBackToTop) {
        setBackToTop(newBackToTop);
      }
    };

    window.addEventListener('scroll', onScrollEvent);
    return () => {
      window.removeEventListener('scroll', onScrollEvent);
    };
  }, [backToTop, props]);

  const scrollToTop = () => {
    const { smoothnessValue } = props;
    if (typeof window !== 'undefined') {
      const sTop = document.documentElement.scrollTop || document.body.scrollTop;
      if (sTop > 0) {
        // dont think this is necessary to suppor to old safari for smooth scroll anymore
        // window.requestAnimationFrame(this.scrollToTop);
        // window.scrollTo(0, sTop - (Math.ceil(sTop / smoothnessValue)));
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    }
  };

  const classNameBackTop = classNames(
    'back-to-top-component',
      { 'back-to-top-component--hide': !backToTop },
      { 'back-to-top-component--visible': backToTop }
    );

    return (
      // eslint-disable-next-line
      <button type="button" onClick={scrollToTop} data-component="BackToTop">
        <i className={classNameBackTop} />
      </button>
    );
}

BackToTop.defaultProps = {
  scrollBreakpoint: 500,
  smoothnessValue: 5
};

BackToTop.propTypes = {
  scrollBreakpoint: PropTypes.number,
  smoothnessValue: PropTypes.number
};

BackToTop.dataModel = {};
